import { Input } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { DateTimeComponent } from './DateTimeComponent';
import { DateComponent } from './DateComponent';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';
import { textfieldTypes } from '../../../config/constants/mobileFormConstant';
import { CustomCurrencyField } from '../../incidentForm/fields/customCurrencyField';
import { decodeHtmlEntities } from '../../../utility/utility';

const textFieldTypesList = Object.values(textfieldTypes);

const CustomTextField = ({ field, value, onChange, disabledField }) => {
  const { translate: t } = useDictionaryTranslation();
  const inputTypeId = field.typeTextField?.id ?? field.typeTextField;
  const inputTypeData = textFieldTypesList.find((x) => x.id === inputTypeId) ?? textfieldTypes.TEXT;

  if (inputTypeData.id === textfieldTypes.CURRENCY.id) {
    return <CustomCurrencyField value={value} field={field} onChange={onChange} disabledField={disabledField}/>;
  }

  if (inputTypeData.id === textfieldTypes.DATETIME.id) {
    return <DateTimeComponent value={value} field={field} onChange={onChange} disabledField={disabledField} />;
  }

  if (inputTypeData.id === textfieldTypes.DATE.id) {
    return <DateComponent value={value} field={field} onChange={onChange} disabledField={disabledField} />;
  }

  const onChangeValue = (e) => {
    onChange(e.target.value);
  };

  return (
    <>
      <Input
        placeholder={decodeHtmlEntities(t('customFieldPlaceholder', { label: field.label }))}
        type={inputTypeData.name}
        onChange={onChangeValue}
        defaultValue={value}
        disabled={disabledField}
      />
    </>
  );
};

CustomTextField.propTypes = {
  field: PropTypes.shape({
    idInput: PropTypes.string,
    label: PropTypes.string,
    obligatory: PropTypes.bool,
    typeTextField: PropTypes.oneOfType([PropTypes.shape({ id: PropTypes.number }), PropTypes.number]),
    value: PropTypes.string,
  }),
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabledField: PropTypes.bool,
};

export default CustomTextField;
